import React from "react";
import styled from "styled-components";

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
	@media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;

export const HeroImage = styled.img`
    height: 424px;
    object-fit: cover;
    display: block;
    margin: auto;
	@media only screen and (max-width: 767px){
		display: none;
	}
`;

export const MobileImage = styled.img`
	@media (min-width: 768px){
		display: none;
	}
	@media (max-width: 767px){
		height: 248px;
		width: auto;
		display: flex;
		margin: auto;
	}

`;